import gql from 'graphql-tag'

// eslint-disable-next-line import/prefer-default-export
export const GET_AVAILABLE_FEATURES = gql`
  query getAvailableFeatures {
    getAvailableFeatures
  }
`;